import { useContext } from 'react'
import { Body, Content, ContentWrapper, Footer, SidebarOverlay } from './styled'
import Topbar from 'components/Topbar'
import Sidebar from 'components/Sidebar'
import { Context } from 'contexts/context'

const Base = (ChildrenComponent) => {
  const ComponentBase = (props) => {
    const { toggle, setToggle } = useContext(Context)

    return (
      <Body>
        <Sidebar />
        {toggle && <SidebarOverlay onClick={() => setToggle(false)} />}
        <ContentWrapper>
          <Topbar />
          <Content>
            <ChildrenComponent {...props} />
          </Content>
          <Footer />
        </ContentWrapper>
      </Body>
    )
  }

  return ComponentBase
}

export default Base
